export function isQwenRoomEnabled(): boolean {
  const flag = import.meta.env.VITE_QWEN_ROOM_ENABLED;
  if (flag === 'true') return true;
  if (flag === 'false') return false;
  return typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function qwenRoomUrl(): string {
  const local = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
  return local ? '/qwen-api/arena/view' : 'https://api.dubya.ai/arena/view';
}
